
    import AuthBox from "@/components/auth/auth-box.vue";
    import NavMenu from "@/components/nav-menu.vue";
       
    export default {
        name: 'HeaderMarketing',
        components: {
            "nav-menu": NavMenu,
            "auth-box": AuthBox,
        },
    }

